/**
 * 无限画布常量
 */
import type { CanvasBackground, CanvasTheme } from './types';

export const ZOOM_MIN = 0.2;
export const ZOOM_MAX = 4;
export const ZOOM_STEP = 0.1;

export const NODE_HANDLE_SIZE = 10;

export const HISTORY_LIMIT = 50;
export const AUTOSAVE_DEBOUNCE_MS = 1000;

export const DEFAULT_NODE_SIZES: Record<string, { width: number; height: number }> = {
  text: { width: 320, height: 160 },
  // 图片默认卡片 = 内容层 padding(28) + 1:1 媒体框(296) + 边框(4) = 328：空态与成品占位完全一致
  image: { width: 320, height: 328 },
  // 视频默认卡片 = 内容层 padding(28) + 16:9 媒体框(189) + 边框(4) = 221：空态与成品占位完全一致
  video: { width: 360, height: 221 },
  audio: { width: 280, height: 120 },
  generate_image: { width: 320, height: 250 },
  generate_video: { width: 360, height: 190 },
  image_group: { width: 360, height: 360 },
  video_group: { width: 380, height: 320 },
  llm: { width: 360, height: 320 },
  agent: { width: 340, height: 300 },
  style_card: { width: 200, height: 240 },
  group: { width: 760, height: 480 },
};

export const BACKGROUND_LABELS: Record<CanvasBackground, string> = {
  dot: '点阵',
  grid: '网格',
  blank: '空白',
};

export const THEME_LABELS: Record<CanvasTheme, string> = {
  light: '浅色',
  dark: '深色',
};

// 节点最大数与连线最大数（与后端硬限制保持一致）
export const MAX_NODES_PER_PROJECT = 500;
export const MAX_EDGES_PER_PROJECT = 1000;

// 视频组导出限制（与后端 videoConcatService 的硬限制保持一致）
export const VIDEO_GROUP_MAX_CLIPS = 20;
export const VIDEO_GROUP_MAX_TOTAL_SECONDS = 30 * 60;

// IndexedDB 不可用降级为 data URL 直存节点时的上限（base64 字符数）。
// 超限图片会导致每次快照保存都携带大体积 base64，后端按 256KB/节点拒绝。
export const MAX_FALLBACK_DATA_URL_LENGTH = 200_000;
